'use strict';

angular.module('selfAccessRequestSharedControllers')

	.controller('ConfirmRolesRequiringAdmAccountController', ['$scope', function ($scope) {

		$scope.getTemplateUrl = function(selfAccessRequestTemplate) {
			return '/app/shared/components/controllers/selfAccessRequest/ConfirmRolesRequiringAdmAccountItem.' + selfAccessRequestTemplate + '.tpl.html';
		}

		$scope.confirm = function () {
			$scope.continueConfirmSystemDecisions();
		}

		$scope.confirmDisabled = function() {
			return _.some($scope.currentUserSystemRoleWithRequiringAdmAccountDecisionList,
				function(item) {
					return item.confirmedForAdm === false;
				});
		}

		//$scope.ctxtSelectSameAsEmp = {};

		//// Search Employees
		//$scope.searchEmployees = function () {
		//	var searchTerm = $scope.ctxtSelectSameAsEmp.searchTerm;
		//	$scope.resetDecisionContainer();

		//	if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
		//		$scope.availableSameAsEmployees = [];
		//		return;
		//	}

		//	searchService
		//		.searchActiveEmployees(searchTerm)
		//		.then(function (foundEmployees) {
		//			$scope.availableSameAsEmployees = foundEmployees;
		//		});
		//};

		//// Select SameAs Employee
		//$scope.selectSameAsEmployee = function (emp) {
		//	$scope.newSameAsEmployee(emp)
		//		.then(function (decisionContainer) {
		//			$scope.ctxtSelectSameAsEmp.decisionContainer = decisionContainer;
		//		});
		//};

		//// Reset Decision Container
		//$scope.resetDecisionContainer = function () {
		//	$scope.ctxtSelectSameAsEmp.decisionContainer = null;
		//};

	}]);
